import { Box, styled } from "@mui/material"
import { FC } from "react"
import { createPortal } from "react-dom"
import { useSnapshot } from "valtio"
import { CurrentTestState } from "../../../storage"
import { PROMPT_CONTAINER_ID } from "../../../constants"

interface PromptProps {
  id?: string
  accessibilityAttr: { [key: string]: string }
}

export const Prompt: FC<React.PropsWithChildren<PromptProps>> = ({
  id,
  children,
  accessibilityAttr
}) => {
  const { currentTestPart } = useSnapshot(CurrentTestState)

  if (currentTestPart?.twoColumnLayout) {
    return createPortal(
      <PromptContainer id={id} {...accessibilityAttr} tabIndex={-1}>
        {children}
      </PromptContainer>,
      document.getElementById(PROMPT_CONTAINER_ID)
    )
  }

  return (
    <PromptContainer id={id} {...accessibilityAttr} tabIndex={-1}>
      {children}
    </PromptContainer>
  )
}

const PromptContainer = styled(Box)(
  ({ theme }) => `
  color: ${theme.palette.grey[800]};
  margin-bottom: ${theme.spacing(2.5)};

  // Quill content inside question prompt should grow naturally.
  // This avoids nested scrollbars (prompt scroll inside question scroll)

  & .ql-container, & .ql-editor {
    height: auto !important;
    overflow: visible !important;
  }
`
)
